import z from "zod";

export const getCrewDefinitionManagerSlotParamSchema = z.object({
	crewDefinitionId: z.uuid(),
	managerSlotId: z.uuid(),
});

export type GetCrewDefinitionManagerSlotParamSchema = z.infer<
	typeof getCrewDefinitionManagerSlotParamSchema
>;
